// extracted by mini-css-extract-plugin
module.exports = {"form":"InputForm_form__2PYRW","disabledButton":"InputForm_disabledButton__aX792"};